var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.charity_id)?_c('NewCharity',{attrs:{"mode":"edit","charity_id":_vm.charity_id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }